import styled from 'styled-components';
import { BLACK, BLUE, GRAYSCALE_400, GRAYSCALE_500, NEUTRAL_100, WHITE } from "@styles/colors";
import { INTER } from "@styles/fonts";
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  padding: 32px 12px 100px 12px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;

export const Content = styled.div`
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  margin-bottom: 100px;
`;

export const HeaderContainer = styled.div`
  padding: 16px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${NEUTRAL_100};
`;

export const HeaderTitle = styled.span`
  font-family: ${INTER.medium};
  color: ${BLACK};
`;

export const HistoryLink = styled.span`
  font-family: ${INTER.medium};
  color: ${BLUE};
  cursor: pointer;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
`;

export const DropdownContainer = styled.div`
  padding-bottom: 4px;
  border-bottom: 1px solid ${NEUTRAL_100};
`;

export const InputContainer = styled.div`
  border-bottom: 1px solid ${NEUTRAL_100};
  padding-bottom: 12px;
  margin-top: 24px;
`;

export const FooterText = styled.div`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.regular};
  font-size: 12px;
  margin-top: 12px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: ${WHITE};
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
  margin: 16px 0;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_400};
`;

export const SaveToFavoritesContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const HintContainer = styled.div`
  position: relative;
  margin-top: 16px;
  border-radius: 6px;
  padding: 1px;
  background: linear-gradient(135deg, #C9ECFF 1%, #82ADFF 33%, #7B69FF 62%, #9B1BFF 95%);
`;

export const HintInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 5px;
  background: linear-gradient(135deg, #F8FBFF 0%, #F8F6FF 100%);
`;

export const HintText = styled.span`
  flex: 1;
  font-family: ${INTER.medium};
  font-size: 12px;
  line-height: 16px;
  color: ${GRAYSCALE_500};
`;
